/* eslint-disable react/jsx-key */
/* eslint-disable react/no-array-index-key */
/* eslint-disable import/no-extraneous-dependencies */
import { NumericTextBox } from "@progress/kendo-react-inputs";
import React, { useMemo } from "react";
import { useTable } from "react-table";

function NoOfNotesCell({
  cell: { value },
  row: { index },
  column: { id },
  updateTxtData,
  addKeyInDenomination,
}) {
  const onChange = (e) => {
    let value = e.target.value;
    if (e.target.value === "" || parseInt(e.target.value) < 0) value = 0;
    updateTxtData(index, id, value);
  };

  const onBlur = (e) => {
    let value = e.target.value;
    if (e.target.value === "" || parseInt(e.target.value) < 0) value = 0;
    addKeyInDenomination(index, id, value);
  };

  return (
    <NumericTextBox
      step={0}
      spinners={false}
      className="w-full h-10"
      value={value}
      format="n0"
      onChange={onChange}
      onBlur={onBlur}
      min={0}
      required
    />
  );
}

function KeyInCashEntry({ data, updateTxtData, addKeyInDenomination }) {
  const columns = useMemo(
    () => [
      {
        Header: "Denomination",
        accessor: "denomination",
        Cell: ({ row }) => `${row.original.denomination} ${row.original.shape}`,
      },
      {
        Header: "No of Notes",
        accessor: "count",
        Cell: NoOfNotesCell,
      },
    ],
    []
  );

  const tableInstance = useTable({
    columns,
    data,
    updateTxtData,
    addKeyInDenomination,
  });

  const { getTableProps, headerGroups, getTableBodyProps, rows, prepareRow } =
    tableInstance;

  return (
    <div className="table-wrapper bg-gray-200">
      <table {...getTableProps()} width="100%">
        <thead>
          {headerGroups.map((headerGroup) => (
            <tr className="bg-info" {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map((column, i) => (
                <th
                  key={`th_${i}`}
                  className="text-center text-white py-2 bg-secondary"
                  {...column.getHeaderProps()}
                >
                  {column.render("Header")}
                </th>
              ))}
            </tr>
          ))}
        </thead>
        <tbody {...getTableBodyProps()}>
          {rows.map((row, i) => {
            prepareRow(row);
            return (
              <tr className="bg-normal" key={`tr_${i}`} {...row.getRowProps()}>
                {row.cells.map((cell, i) => {
                  return (
                    <td
                      key={`td_${i}`}
                      className="text-start p-1 text-black pl-3"
                      {...cell.getCellProps}
                    >
                      {cell.render("Cell")}
                    </td>
                  );
                })}
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}

export default React.memo(KeyInCashEntry);
